import { AnalyticsEventType, BillingData, EntityWithText, NLPEventInterface, Slug } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class AnalyticsAPI {
  static async createUserEvent(type: AnalyticsEventType, orgId: number, userId: number, agentMemberId?: number) {
    return APIService.Analytics.post(`/v0/user_event`, {
      context: APIService.Analytics.context,
      type: type,
      bot_id: String(orgId),
      bot_user_id: String(userId),
      human_user_id: agentMemberId ? String(agentMemberId) : undefined
    });
  }
  static async createNLPEvent(
    type: AnalyticsEventType,
    text: string,
    orgId: number,
    userId: number,
    questSlug: string,
    questName: string,
    source: string,
    intent: string,
    entities: { [entityId: string]: EntityWithText },
    score: number
  ) {
    const body: Partial<NLPEventInterface> = {
      context: APIService.Analytics.context,
      handled: type === AnalyticsEventType.NLP_HANDLED ? true : false,
      text: text,
      botId: String(orgId),
      userId: String(userId),
      questSlug: questSlug,
      questName: questName,
      source: source,
      intent: intent,
      entities: entities,
      score: score
    };
    return APIService.Analytics.post(`/nlp/event`, body);
  }

  static async createQuestEvent(orgId: number, userId: number, questSlug: Slug, questName: string) {
    return APIService.Analytics.post(`/quests/event`, {
      context: APIService.Analytics.context,
      botId: String(orgId),
      userId: String(userId),
      questSlug: questSlug,
      questName: questName
    });
  }

  static async getBillingData(): Promise<BillingData[]> {
    return APIService.Server.get("/admin/billing");
  }

  static async getOrgLocationsExport(orgId: number): Promise<
    {
      locationName: string;
      isLive: boolean;
      locationCreated: string;
      locationDeleted: string | null;
      groupName: string;
      fmsType: string;
    }[]
  > {
    return APIService.Server.get(`/admin/org/${orgId}/locations-export`);
  }
}
